import { render, staticRenderFns } from "./TheFooterNumbers.vue?vue&type=template&id=8b4484be&"
import script from "./TheFooterNumbers.vue?vue&type=script&lang=js&"
export * from "./TheFooterNumbers.vue?vue&type=script&lang=js&"
import style0 from "./TheFooterNumbers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports